
import React from 'react';

interface DownloadFooterProps {
  description?: string;
}

const DownloadFooter: React.FC<DownloadFooterProps> = ({ description }) => {
  if (!description) return null;
  
  return (
    <div className="pt-4 border-t">
      <p className="text-sm text-muted-foreground">
        {description}
      </p>
    </div>
  );
};

export default DownloadFooter;
